import React from "react";
import { Button } from 'primereact/button';
import { InputText } from "primereact/inputtext";
import { useFormik } from 'formik';
import { Calendar } from 'primereact/calendar';

import { classNames } from 'primereact/utils';
import { Panel } from 'primereact/panel';
import {
    Form,
    redirect,
    useNavigate,
    useSubmit
} from "react-router-dom";
import { createExpense } from "../../../data/loca/expenses";

export async function action({ request, params }) {
    const formData = await request.formData();
    const data = Object.fromEntries(formData);
    await createExpense(data, params.toolId);

    return redirect(`/monoutil/${params.toolId}`);
}


export default function AddExpense() {
    const navigate = useNavigate();
    const submit = useSubmit();


    // Formik ---------------------

    const formik = useFormik({
        initialValues: {
            description: '',
            totalPrice: ''
        },
        validate: (data) => {
            let errors = {};

            if (!data.description) {
                errors.description = 'description is required.';
            }
            if (!data.totalPrice) {
                errors.totalPrice = 'totalPrice is required.';
            }
           
           
            return errors;
        },
        onSubmit: async (data) => {
            submit(data, { method: "post" })
        }
    });

    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

    //----------------------------------------



    return (
        <div>
           
            <Form method="post" id="thumbnail-form" onSubmit={formik.handleSubmit}>
                <Panel header="Ajout d'une dépense">
                       
                    <div className="contentForm">

                        <span className="p-float-label">
                        <InputText id="totalPrice" name="totalPrice" value={formik.values.totalPrice}
                                keyfilter="num"
                                onChange={(e) => {
                                    formik.setFieldValue('totalPrice', e.target.value);
                                }}
                            className={classNames({ 'p-invalid': isFormFieldInvalid('totalPrice') })}
                            />
                        <label htmlFor="totalPrice">Montant total</label>

                        </span>
                        <span className="p-float-label">
                        <InputText id="description" name="description" value={formik.values.description}
                              
                                onChange={(e) => {
                                    formik.setFieldValue('description', e.target.value);
                                }}
                            className={classNames({ 'p-invalid': isFormFieldInvalid('description') })}
                            />

                        <label htmlFor="description">Description</label>
                        </span>
                        <span className="p-float-label">
                            <Calendar id="purchaseDate" name="purchaseDate" value={formik.values.purchaseDate}
                                dateFormat="dd/mm/yy"
                                onChange={(e) => {
                                    formik.setFieldValue('purchaseDate', e.target.value);
                                }}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('purchaseDate') })}
                            />
                            <label htmlFor="purchaseDate">Date d'achat</label>
                        </span>

                        <p>
                            <Button type="submit" size="small">Enregistrer</Button>
                            <Button severity="secondary" type="button"
                                size="small"
                                onClick={() => {
                                    navigate(-1);
                                }}>Annuler</Button>
                        </p>

                    </div>

                    <div className="contentForm"></div >
                </Panel>
               
             
            </Form>
            
            
        </div>
    );
}